import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-loading-cards',
  standalone: true,
  template: `
    <div class="loading-grid">
      @for (i of countArray; track i) {
        <div class="skeleton-card"></div>
      }
    </div>
  `,
  styles: [`
    .loading-grid { 
      display: grid; 
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); 
      gap: 1rem; 
      width: 100%;
    }
    .skeleton-card { 
      height: 120px; 
      background: var(--bg-card, #ffffff); 
      border-radius: 14px; 
      animation: pulse 1.5s ease-in-out infinite; 
      border: 1px solid var(--border, #e5e7eb);
    }
    @keyframes pulse { 
      0%, 100% { opacity: 1; } 
      50% { opacity: 0.5; } 
    }
  `]
})
export class LoadingCardsComponent {
  count = input<number>(6);
  get countArray() { return Array.from({ length: this.count() }, (_, i) => i); }
}
